import { progamersApi } from "@/config/axios.config.ts";
import { BaseResponseBadget } from "@integration/application/interfaces/base.ts";
import { IBadgetAssigmentsDTO } from "@integration/badget/interfaces/badget.interface.ts";

export default function badgetService() {
  const getBadgetsTeamByIdPublic = async (
    entityId: string
  ): Promise<BaseResponseBadget<IBadgetAssigmentsDTO[]>> => {
    const type = "TEAM";
    const { data } = await progamersApi.get(
      `public/badgets/${entityId}/${type}`
    );
    return data;
  };

  return { getBadgetsTeamByIdPublic };
}